import { FileResponse } from '@agent/agent-interface/contact-view/chat/model/chat-attachment-message';
import { ChatbotExchangeMessage } from '@agent/agent-interface/contact-view/chat/model/chatbot-exchange-message';

import { MessageType } from './message-type';

export const BOT_CSR_ID = 'Bot';

export class ChatMessage {
  public type: MessageType;
  public content: string;
  public lastName: string;
  public firstName: string;
  public customUserId?: string;
  public customerId?: string;
  public csrId: string;
  public csrLogin: string;
  public csrNickname: string;
  public token?: string;
  public extraMap?: Map<string, string>;
  public contactId?: string;
  public contactFlowUri?: string;
  public engagementStrategyUuid?: string;
  public date: number;
  public consent?: boolean;
  public attachment?: FileResponse;
  public chatbotExchangeMessage?: ChatbotExchangeMessage;

  constructor(
    type: MessageType,
    content: string,
    lastName: string,
    firstName: string,
    customUserId: string | undefined,
    customerId: string | undefined,
    csrId: string,
    csrLogin: string,
    csrNickname: string,
    date: number = 0,
    token?: string,
    extraMap?: Map<string, string>,
    contactId?: string,
    contactFlowId?: string,
    engagementStrategyUuid?: string,
    consent?: boolean,
    attachment?: FileResponse,
    chatbotExchangeMessage?: ChatbotExchangeMessage
  ) {
    this.type = type;
    this.content = content;
    this.lastName = lastName;
    this.firstName = firstName;
    this.customUserId = customUserId;
    this.customerId = customerId;
    this.csrId = csrId;
    this.csrLogin = csrLogin;
    this.csrNickname = csrNickname;
    this.date = date || Date.now();
    this.token = token;
    this.extraMap = extraMap;
    this.contactId = contactId;
    this.contactFlowUri = contactFlowId;
    this.engagementStrategyUuid = engagementStrategyUuid;
    this.consent = consent;
    this.attachment = attachment;
    this.chatbotExchangeMessage = chatbotExchangeMessage;
  }

  public static fromWebSocket(o: any) {
    return new ChatMessage(
      o.type,
      o.content,
      o.lastName,
      o.firstName,
      o.customUserId,
      o.customerId,
      o.csrId,
      o.csrLogin,
      o.csrNickname,
      o.date,
      o.token,
      o.extraMap,
      o.contactId,
      o.contactFlowUri,
      o.engagementStrategyUuid,
      o.consent,
      o.attachment,
      o.chatbotExchangeMessage
    );
  }

  public isFromCustomer(): boolean {
    return (
      (this.csrId === null || this.csrId === undefined || this.csrId === '') &&
      this.type !== MessageType.CHAT_AUTOMATIC_MESSAGE &&
      this.type !== MessageType.AUTOMATIC
    );
  }

  public isFromBot(): boolean {
    return this.csrId === BOT_CSR_ID;
  }

  public isFromRealAgent(): boolean {
    return !this.isFromCustomer() && !this.isFromBot();
  }
}
